import {
  Divider,
  IconButton,
  List,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import { Skeleton } from "antd";
import React, { useContext, useEffect, useState } from "react";
import PsContext from "../../context";
import { _MY_TIME_TABLE } from "../../models/utilities";
import {
  courseName,
  getAscSortOrder,
  groupByMultiple,
  NoData,
  SkeltonLoop,
  timeTableDayFromNumber,
  upperCase,
  yearBySem,
} from "../../utils";
const FullTimetable = (props) => {
  const context = useContext(PsContext);

  const [loader, setLoader] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [dataView, setDataView] = useState([]);

  const totalDays = context.settingValue("attendance_day_order_count");
  const hoursPerDay = context.settingValue("hour_for_attendance_per_day");
  let dayOrderInDayName = context.settingValue(
    "attendance_dayorder_as_day_name"
  );

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    setLoader(true);
    _MY_TIME_TABLE({ type: "today", full_timetable: "1" }).then((res) => {
      if (res.status == "1") {
        let d = res.data.sort(getAscSortOrder("day_value", true));
        let dv = groupByMultiple(d, function (obj) {
          return [obj.day_value];
        });
        setDataList(res.data);
        setDataView(dv);
      } else {
        setDataList([]);
      }
      setLoader(false);
    });
  };

  return (
    <>
      {loader &&
        SkeltonLoop(
          5,
          <div className="border-bottom p-3">
            <Skeleton.Input
              size="small"
              loading={true}
              className="mb-1"
              active
              style={{ width: "355px" }}
              block={true}
            />
            <Skeleton.Input size="small" loading={true} active block={true} />
          </div>
        )}
      {!loader && dataList.length < 1 && <NoData imgWidth="130px" />}
      {dataView.map((items, i) => {
        const item = items[0];
        return (
          <>
            <div className="bg-light p-2 fw-bold">
              {timeTableDayFromNumber(item.day_value, dayOrderInDayName)}
            </div>
            <List component="nav" aria-labelledby="nested-list-subheader">
              {items.map((row, j) => {
                return (
                  <>
                    <ListItemButton>
                      <ListItemText
                        primary={
                          <>
                            {row.subject_code}-{row.subject_name}
                          </>
                        }
                        secondary={
                          <>
                            {courseName(row, true)} {yearBySem(item.semester)}
                            {"-"}
                            {upperCase(item.section)}
                            {row.room_id && (
                              <div>
                                <span
                                  className="fw-bold bg-blue-50 p-1 mt-2"
                                  style={{ fontSize: "14px", color: "blue" }}
                                >
                                  {row.block_name} {" - "}
                                  {row.room_name}
                                </span>
                              </div>
                            )}
                          </>
                        }
                      ></ListItemText>
                      <IconButton
                        edge="end"
                        sx={{ fontSize: "14px", fontWeight: "bold" }}
                      >
                        H-{row.hour_value}
                      </IconButton>
                    </ListItemButton>
                    <Divider />
                  </>
                );
              })}
            </List>
          </>
        );
      })}
    </>
  );
};
export default FullTimetable;
